var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M11.5 4.75a.75.75 0 0 1 0-1.5H16a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.81l-6.22 6.22a.75.75 0 0 1-1.06-1.06l6.22-6.22zm-6 1.5a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75H13a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 1 1.5 0v3A2.25 2.25 0 0 1 13 16.75H5.5a2.25 2.25 0 0 1-2.25-2.25V7A2.25 2.25 0 0 1 5.5 4.75h3a.75.75 0 0 1 0 1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgExternalLink;